import { api } from "@/api";
const recipeStore = {
  state: {
    updated: null,
    recipes: [],
    recipeLoading: false,
    ingredients: [],
    products: [],
    productLoading: false,
    recipeUnitSelection: ["g", "ml", "kg", "l", "lb"],
    recipeProductUnitSelection: ["g", "ml", "kg", "l", "lb"],
    recipeProductInventoryUnitSelection: ["g", "ml", "kg", "l", "lb", "cs"],
    allowedUnits: [
      "g",
      "ml",
      "mg",
      "kg",
      "l",
      "lb",
      "kl",
      "tsp",
      "Tbs",
      "cup",
      "oz"
    ],
    customUnits: []
  },
  getters: {
    getLastUpdate(state) {
      return state.updated;
    },
    getRecipes(state) {
      return state.recipes !== undefined ? state.recipes : [];
    },
    getIntermediateRecipe(state) {
      return state.recipes.filter(r => r.est_intermediaire === true) !==
        undefined
        ? state.recipes.filter(r => r.est_intermediaire === true)
        : [];
    },
    getIngredients(state) {
      return state.ingredients;
    },
    getIngredientsByRecipe(state) {
      return id => {
        return state.ingredients.filter(i => i.pk_recette === id);
      };
    },
    getIngredientsNotInRecipe(state) {
      return id => {
        return state.ingredients.filter(i => i.pk_recette !== id);
      };
    },
    getIngredientById(state) {
      return id => {
        return state.ingredients.find(i => i.id === id);
      };
    },
    getProducts(state) {
      return state.products.filter(x => x.is_deleted === false) !== undefined
        ? state.products.filter(x => x.is_deleted === false)
        : [];
    },
    getAllProducts(state) {
      return state.products !== undefined ? state.products : [];
    },
    getProductById(state) {
      return id => {
        return state.products.find(p => p.id === id);
      };
    },
    getAllowedUnits(state) {
      return [...state.allowedUnits, ...state.customUnits.map(x => x.name)];
    },
    getCustomUnits(state) {
      return state.customUnits;
    },
    getCustomUnitsValues(state) {
      return state.customUnits.map(x => x.name);
    },
    getRecipeLoading(state) {
      return state.recipeLoading;
    },
    getProductLoading(state) {
      return state.productLoading;
    }
  },
  mutations: {
    setUpdated(state, value) {
      state.updated = value;
    },
    setProducts(state, value) {
      state.products = value;
    },
    addRecipeProduct(state, value) {
      state.products.push(value);
    },
    setIngredients(state, value) {
      state.ingredients = value;
    },
    addIngredient(state, value) {
      state.ingredients.push(value);
    },
    setRecipes(state, value) {
      state.recipes = value;
    },
    setCustomUnits(state, value) {
      state.customUnits = value;
    },
    setRecipeLoading(state, value) {
      state.recipeLoading = value;
    },
    setProductLoading(state, value) {
      state.productLoading = value;
    }
  },
  actions: {
    async loadProducts({ commit, state }, payload) {
      if (state.products.length > 0) {
        setTimeout(async () => {
          try {
            commit("setProductLoading", true);
            const res = await api.getRecipeProducts(payload);
            commit("setProducts", res);
          } finally {
            commit("setProductLoading", false);
          }
        }, 5);
        return Promise.resolve();
      }
      try {
        commit("setProductLoading", true);
        const res = await api.getRecipeProducts(payload);
        commit("setProducts", res);
      } finally {
        commit("setProductLoading", false);
      }
    },
    async addRecipeProduct({ commit }, payload) {
      const res = await api.postRecipeProduct(payload);
      commit("addRecipeProduct", res);
    },
    async loadRecipes({ commit, state }, payload) {
      if (state.recipes.length > 0) {
        setTimeout(async () => {
          try {
            commit("setRecipeLoading", true);
            const res = await api.getRecipes(payload);
            commit("setRecipes", res);
          } finally {
            commit("setRecipeLoading", false);
          }
        }, 5);
        return Promise.resolve();
      }
      try {
        commit("setRecipeLoading", true);
        const res = await api.getRecipes(payload);
        commit("setRecipes", res);
      } finally {
        commit("setRecipeLoading", false);
      }
    },
    async addIngredient({ commit }, payload) {
      const res = await api.postRecipeIngredient(payload);
      commit("addIngredient", res);
    },
    async loadIngredients({ commit, state }, payload) {
      if (state.ingredients.length > 0) {
        setTimeout(async () => {
          const res = await api.getRecipeIngredients(payload);
          commit("setIngredients", res);
        }, 5);
        return Promise.resolve();
      }
      const res = await api.getRecipeIngredients(payload);
      commit("setIngredients", res);
    },
    async loadCustomUnits({ commit, state }) {
      if (state.customUnits.length > 0) {
        setTimeout(async () => {
          const res = await api.getCustomUnits();
          commit("setCustomUnits", res);
        }, 5);
        return Promise.resolve();
      }
      const res = await api.getCustomUnits();
      commit("setCustomUnits", res);
    },
    async loadAllRecipeStore({ commit, state }, payload) {
      if (
        state.recipes.length > 0 &&
        state.products.length > 0 &&
        state.ingredients.length > 0 &&
        state.customUnits.length > 0
      ) {
        setTimeout(async () => {
          try {
            commit("setRecipeLoading", true);
            commit("setProductLoading", true);
            const res = await Promise.all([
              api.getRecipeProducts(payload),
              api.getRecipes(payload),
              api.getRecipeIngredients(payload),
              api.getCustomUnits()
            ]);
            commit("setProducts", res[0]);
            commit("setIngredients", res[2]);
            commit("setRecipes", res[1]);
            commit("setCustomUnits", res[3]);
          } finally {
            commit("setRecipeLoading", false);
            commit("setProductLoading", false);
          }
        }, 5);
        return Promise.resolve();
      } else {
        try {
          commit("setRecipeLoading", true);
          commit("setProductLoading", true);
          const res = await Promise.all([
            api.getRecipeProducts(payload),
            api.getRecipes(payload),
            api.getRecipeIngredients(payload),
            api.getCustomUnits()
          ]);
          commit("setProducts", res[0]);
          commit("setIngredients", res[2]);
          commit("setRecipes", res[1]);
          commit("setCustomUnits", res[3]);
        } finally {
          commit("setRecipeLoading", false);
          commit("setProductLoading", false);
        }
      }
    }
  }
};

export default recipeStore;
